import React from "react";
import HotelsResultsMockupPage from "../../features/hotelsResultsMockup/HotelsResultsMockupPage";

/** Design mockup בלבד — עמוד תוצאות מלונות HotelsRiver, ללא API. */
export default function HotelsResultsMockupStandalonePage() {
  return <HotelsResultsMockupPage />;
}
